import { ComponentType, createContext } from 'react'
import { JSONRendererProps } from '@utils/JSONRenderer'

export type PageTypeSpecificJSONRendererProps = Pick<
  JSONRendererProps,
  'children'
>

export type RendererContextType =
  ComponentType<PageTypeSpecificJSONRendererProps>

const RendererContext = createContext<RendererContextType | undefined>(
  undefined
)

export default RendererContext
